import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { saveReturnUrl } from "@/lib/postLoginRedirect";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (!user) {
    // Mirror to sessionStorage so the return URL survives a Google OAuth
    // round-trip (router state is lost when leaving our origin).
    saveReturnUrl(loc.pathname + loc.search);
    return <Navigate to="/login" state={{ from: loc }} replace />;
  }
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
